import { Check, DescriptionOutlined } from '@mui/icons-material'
import { catalogColumnType, catalogFilterColumnType, catalogTabType } from '../catalogTypes'

export type gitItemType = {
  id: string
  oemCode: string
  contractCeilingPrice: number | undefined //discount price to GSA (w/ IFF)
  clinValid: string | undefined //auto-generated clin
  clinApproved: string | undefined
  gsaSchedulePrice: number | undefined
  awardNumber: string | undefined
  productTitle: string | undefined
  uoi: string | undefined
  coo: string | undefined
  cpl: string | undefined
  discountCatalogPrice: number | undefined
  discountGsaPriceExcludingIff: number | undefined
  discountGsaPriceIncludingIff: number | undefined
  gitBpaSellPriceIncludingIff: number | undefined
  sinsProposed: string | undefined
  manufacturer: string | undefined
  mfrPartNumber: string
  description: string | undefined
  warranty: string | undefined
  deliveryTime: string | undefined
  transactionType: string | undefined
  productGroup: string | undefined
  status: 'inProgress' | 'processing' | 'completed' | 'failed' | undefined
  uploadedFile: string | undefined
  errorMessage: string | undefined
  productName: string | undefined
  tdsnxPartNumber: string | undefined
  sku: string | undefined
  gsaStatus: string | undefined
  pl: string | undefined
  notes: string | undefined
  msrp: number | undefined
  gsaNteIncludingIff: number | undefined
  unitPrice2GitBpa: number | undefined
  upc: string | undefined
  bpa: string | undefined
  osts: string | undefined
  'addMod#': string | undefined
  samUei: string | undefined
  duns: string | undefined
  catalogDate: Date
  addProductDescription: string | undefined
  gsaPrice: number | undefined
  gitBpa: number | undefined
  category: string | undefined
}

const ALL_CTA_COLUMNS: catalogColumnType[] = [
  { key: 'sinsProposed', label: 'SIN', width: '100px' },
  { key: 'manufacturer', label: 'Manufacturer', width: '250px' },
  { key: 'mfrPartNumber', label: 'Part Number', width: '150px' },
  { key: 'description', label: 'Product Description', width: '300px' },
  {
    key: 'listPrice',
    label: 'List Price',
    width: '150px',
    inputType: 'currency',
    align: 'right',
  },
  {
    key: 'catalogPrice',
    label: 'Catalog Price',
    width: '150px',
    inputType: 'currency',
    align: 'right',
  },
  { key: 'warranty', label: 'Warranty', width: '150px' },
  { key: 'deliveryTime', label: 'Delivery Time', width: '150px' },
  { key: 'transactionType', label: 'Transaction Type', width: '150px' },
  { key: 'productGroup', label: 'Product Group', width: '150px' },
]

const ALL_GIT_COLUMNS: catalogColumnType[] = [
  {
    key: 'contractCeilingPrice',
    label: 'Contract Ceiling Price',
    width: '100px',
    inputType: 'currency',
    align: 'right',
  },
  { key: 'clinValid', label: 'CLIN (Validation)', width: '100px' },
  { key: 'clinApproved', label: 'CLIN (Approved)', width: '100px' },
  { key: 'manufacturer', label: 'Manufacturer', width: '250px' },
  {
    key: 'gsaSchedulePrice',
    label: 'GSA Schedule Price',
    width: '100px',
    inputType: 'currency',
    align: 'right',
  },
  { key: 'mfrPartNumber', label: 'Part Number', width: '150px' },
  { key: 'awardNumber', label: 'Mod No./Award', width: '100px' },
  { key: 'description', label: 'Product Description', width: '300px' },
  { key: 'productTitle', label: 'Product Title', width: '100px' },
  { key: 'uoi', label: 'UOI', width: '100px' },
  { key: 'coo', label: 'COO', width: '100px' },
  {
    key: 'cpl',
    label: 'Commercial Price List (CPL)',
    width: '100px',
    inputType: 'currency',
    align: 'right',
  },
  {
    key: 'discountCatalogPrice',
    label: 'Discount Percentage from Catalog Price',
    width: '100px',
    inputType: 'currency',
    align: 'right',
  },

  {
    key: 'discountGsaPriceExcludingIff',
    label: 'Discount Price to GSA (excluding IFF)',
    width: '100px',
    inputType: 'currency',
    align: 'right',
  },
  {
    key: 'discountGsaPriceIncludingIff',
    label: 'Discount Price to GSA (including IFF)',
    width: '100px',
    inputType: 'currency',
    align: 'right',
  },
  {
    key: 'gitBpaSellPriceIncludingIff',
    label: '2GIT BPA Sell Price (Including IFF)',
    width: '100px',
    inputType: 'currency',
    align: 'right',
  },
]
//47QTCA21A0026
const TD_SYNNEX_CTA_COLUMNS: catalogColumnType[] = [
  { key: 'sinsProposed', label: 'SIN', width: '150px' },
  { key: 'manufacturer', label: 'Manufacturer', width: '150px' },
  { key: 'mfrPartNumber', label: 'MFR Part Number', width: '150px' },
  { key: 'productName', label: 'Product Name', width: '150px' },
  { key: 'tdsnxPartNumber', label: 'TDSNX Part Number', width: '150px' },
  { key: 'sku', label: 'SKU', width: '150px' },
  { key: 'gsaStatus', label: 'GSA Status', width: '150px' },
  { key: 'pl', label: 'PL', width: '100px' },
  { key: 'notes', label: 'Notes', width: '150px' },
  { key: 'description', label: 'Description', width: '300px' },
  {
    key: 'msrp',
    label: 'GSA MSRP',
    width: '150px',
    inputType: 'currency',
    align: 'right',
  },
  {
    key: 'gsaNteIncludingIff',
    label: 'GSA NTE (Incl. IFF)',
    width: '150px',
    inputType: 'currency',
    align: 'right',
  },
  {
    key: 'gitBpa',
    label: '2GIT BPA',
    width: '150px',
    inputType: 'currency',
    align: 'right',
  },
  { key: 'upc', label: 'UPC', width: '150px' },
  { key: 'bpa', label: 'BPA', width: '150px' },
  { key: 'osts', label: 'OSTS', width: '150px' },
  { key: 'addMod#', label: 'ADDMod#', width: '150px' },
]
//47QTCA21A002E
const WESTCON_TDSYNNEX_2GIT_COLUMNS: catalogColumnType[] = [
  { key: 'samUei', label: 'SAM UEI', width: '150px' },
  { key: 'duns', label: 'DUNS', width: '150px' },
  { key: 'vendorName', label: 'Vendor Name', width: '150px' },
  { key: 'sinsProposed', label: 'SIN', width: '100px' },
  { key: 'catalogDate', label: 'Catalog Date', width: '150px' },
  { key: 'manufacturer', label: 'Manufacturer', width: '250px' },
  { key: 'mfrPartNumber', label: 'MFR Part No.', width: '150px' },
  { key: 'description', label: 'Description', width: '300px' },
  { key: 'addProductDescription', label: 'Additional Product Description', width: '300px' },
  {
    key: 'msrp',
    label: 'MSRP',
    width: '150px',
    inputType: 'currency',
    align: 'right',
  },
  {
    key: 'gsaPrice',
    label: 'GSA Price',
    width: '150px',
    inputType: 'currency',
    align: 'right',
  },
  {
    key: 'gitBpa',
    label: '2GIT BPA',
    width: '150px',
    inputType: 'currency',
    align: 'right',
  },
  { key: 'warranty', label: 'Warranty', width: '150px' },
  { key: 'category', label: 'Category', width: '150px' },
]

const modDateColumn = (width: string): catalogColumnType => ({
  key: 'modDate',
  label: 'MOD Date',
  width,
  inputType: 'date',
})

const priceChangeColumns = (width: string): catalogColumnType[] => [
  {
    key: 'oldPrice',
    label: 'Old Price',
    width,
    inputType: 'currency',
  },
  {
    key: 'updatedPrice',
    label: 'Updated Price',
    width,
    inputType: 'currency',
  },
]

const gitColumnEntries = (contract: string, columns: catalogColumnType[]): [string, catalogColumnType[]][] => [
  [contract, columns],
  [
    `${contract}:Modifications`,
    [
      { key: 'modType', label: 'MOD Type', width: '75px' },
      modDateColumn('75px'),
      { key: 'status', label: 'Status', width: '50px' },
      { key: 'uploadedFile', label: 'Uploaded File', width: '150px' },
    ],
  ],
  [`${contract}:MOD Report | Price Increase`, [modDateColumn('75px'), ...priceChangeColumns('75px'), ...columns]],
  [`${contract}:MOD Report | Price Decrease`, [modDateColumn('75px'), ...priceChangeColumns('75px'), ...columns]],
  [`${contract}:MOD Report | Item Additions`, [modDateColumn('75px'), ...columns]],
  [`${contract}:MOD Report | Item Deletions`, [modDateColumn('75px'), ...columns]],
]

const GIT_CONTRACT_COLUMNS: [string, catalogColumnType[]][] = [
  ['47qtca21a001g', ALL_GIT_COLUMNS],
  ['47qtca21a0010', ALL_CTA_COLUMNS],
  ['47qtca21a0026', TD_SYNNEX_CTA_COLUMNS],
  ['47qtca21a002e', WESTCON_TDSYNNEX_2GIT_COLUMNS],
]

export const gitColumnMapping = new Map<string, catalogColumnType[]>(
  GIT_CONTRACT_COLUMNS.flatMap(([contract, columns]) => gitColumnEntries(contract, columns)),
)

const gitTabGroup = (contract: string, label: string = contract.toUpperCase()): [string, catalogTabType[]] => [
  contract,
  [
    { label, icon: <DescriptionOutlined />, source: contract },
    { label: 'Modifications', icon: <Check />, source: `${contract}/modifications`, isModification: true },
    { label: 'MOD Report | Price Increase', source: `${contract}/audit`, modType: 'Price Increase' },
    { label: 'MOD Report | Price Decrease', source: `${contract}/audit`, modType: 'Price Decrease' },
    { label: 'MOD Report | Item Additions', source: `${contract}/audit`, modType: 'Additions' },
    { label: 'MOD Report | Item Deletions', source: `${contract}/audit`, modType: 'Deletions' },
  ],
]

export const gitTabGroups = new Map<string, catalogTabType[]>([
  [
    '47qtca21a001g',
    [
      { label: '47QTCA21A001G', icon: <DescriptionOutlined />, source: 'gs-35f-0002v/47qtca21a001g' },
      { label: 'Modifications', icon: <Check />, source: '47qtca21a001g/modifications', isModification: true },
      { label: 'MOD Report | Price Increase', source: '47qtca21a001g' },
      { label: 'MOD Report | Price Decrease', source: '47qtca21a001g' },
      { label: 'MOD Report | Item Additions', source: '47qtca21a001g' },
      { label: 'MOD Report | Item Deletions', source: '47qtca21a001g' },
    ],
  ],
  gitTabGroup('47qtca21a0010'),
  gitTabGroup('47qtca21a0026'),
  gitTabGroup('47qtca21a002e'),
])

const shareFilter = (keys: string[], cols: catalogFilterColumnType[]) =>
  keys.map(k => [k, cols] as [string, catalogFilterColumnType[]])

export const gitColumnFilter = new Map<string, catalogFilterColumnType[]>([
  ...shareFilter(
    ['47qtca21a001g', '47qtca21a0010', '47qtca21a0026', '47qtca21a002e'],
    [
      { key: 'manufacturer', label: 'Manufacturer' },
      { key: 'mfrPartNumber', label: 'MFR Part No.' },
      { key: 'description', label: 'Description' },
    ],
  ),
])
